export default __webpack_public_path__ + "static/media/websocket.aee0d817.svg";